/* diamond graphics text data */
var graphicsMetaData = {
	"caratText" : "The carat is the standard unit of measurement used to indicate the weight of a diamond. Carat is often confused with size even though it is actually a measure of weight. One carat equals 200 milligrams or 0.2 grams. Remember that while the measurements below are typical, every diamond is unique. <br>One carat (1 ct) equals 0.20 grams and is divided into 100 points <br>(half a carat – 0.50 ct – diamond can be described as a 50 points diamond).<br>The scale below illustrates the typical size relationship between diamonds of increasing carat weights.",
	"cutText" : "Nothing is more impactful on a precious stone's brilliance than its cut. The cut refers to the angles and proportions of a diamond. Known in the industry as ‘fire’, referring to the coloured light reflected, and ‘brilliance’ for the uncoloured light. The cut of a diamond - its form and finish, its depth and width, the uniformity of the facets - determines its beauty. The skill with which a diamond is cut determines how well it reflects and refracts light. A diamond should be cut proportionally, neither very shallow nor very deep, given its dimensions. A diamond’s cut is its most important characteristics and a measure of its apparent beauty.",
	"colorText" : "A diamond’s colour is one of its most significant characteristics, enlisted as a fundamental measure of quality. The diamond colour scale begins at D (colourless) and ends at Z (light yellow). Highest quality diamond stones have no hue in their sparkle and that is their classic splendour, admired for ages. Colourless diamonds allow more light to pass through than a coloured diamond, releasing more sparkle and fire.",
	"clarityText" : "A diamond's clarity refers to the presence of impurities on and within the stone. When diamonds are formed naturally under extreme heat and pressure, imperfections in the crystal structure can form and tiny traces of natural elements are almost always trapped inside called inclusions. The diamond with highest quality on clarity grading is the one with absence of any imperfections which could possibly occur in the stone.",
	"DColor" : "D colour diamonds are absolutely colourless, the rarest gemstones to exist. The most expensive colour grade",
	"EColor" : "E colour range is the second highest quality range of diamonds while examining their transparency. These are rare diamonds and the very slight requires professional expertise to detect any dim tone.",
	"FColor" : "F colour detected by an expert gemologist, but still considered a \"colorless\" grade -- a high-quality diamond.",
	"GColor" : "G graded diamonds with noticeable tint is detectable for experts with a keen eye when compared to diamonds of better grades, but offers excellent value.",
	"HColor" : "H coloured diamonds are near colourless diamonds which still appear totally white or colourless if they are not compared side by side with higher colour graded stones.They are almost completely hue free.",
	"IColor" : "I Colour diamonds are very slightly tinted diamonds and noticeable when compared to diamonds of better grades, but offers great value for money.",
	"JColor" : "J coloured diamonds range have trivial hue. The tint is very ignorable.",
	"KColor" : "K coloured diamonds are slightly tinted diamonds, however, once set in jewellery, especially in yellow gold, it is harder to see the slight yellow tint which the K grade produces.",
	"LColor" : "L colour – We don’t carry lower clarity grades however can be made available on special request. Gemsake currently offers diamonds in the higher range of D-J colour, as these are the only grades we recommend.",
    "MColor": "Diamonds with M Colour have a subtle tint that becomes noticeable to the trained eye. M-grade diamonds have a lovely quality even with a slight color presence, especially when set in jewelry.",
    "NColor": "N Colour diamonds are slightly more noticeable than their M-grade equivalents, with a subtle hint of Colour. These diamonds retain their elegant appearance despite their subtle tint, especially when set in settings that accentuate their inherent beauty.",
	"I1Clarity" : "The Included Diamonds with I1-I3 as the lowest clarity grade on the scale.The imperfections in these diamonds are very much visible to the naked eye.",
	"SI2Clarity" : "The slightly included diamonds, considered to be fine quality, having visible imperfections under magnification range of 10x",
	"SI1Clarity" : "The slightly included diamonds, considered to be fine quality, having visible imperfections under magnification range of 10x",
	"VS2Clarity" : "The very slightly included grade of diamonds which have visible imperfections on the uncovered eye.",
	"VS1Clarity" : "The very slightly included grade of diamonds which have visible imperfections on the uncovered eye.",
	"VVS2Clarity" : "This grade range includes the diamonds which are very, very slightly included. It is almost impossible to detect inclusions under 10x range magnification",
	"VVS1Clarity" : "This grade range includes the diamonds which are very, very slightly included. It is almost impossible to detect inclusions under 10x range magnification.",
	"IFClarity" : "The diamonds in this category are completely flawless with no internal or external inclusions of any kind. These are the rarest diamonds.",
	"excellent cut" : "It is an exceptionally uncommon cut which reflects roughly all the light that enters the precious stone. The excellent Cut refers to the topmost three percent quality diamond stones.",
	"very good cut" : "This cut evaluation is a representation of around fifteen percent of the top quality jewels which reflects just about as much light as falls into the precious stone, one grade lower than the Excellent cut’s reflection which is almost absolute.",
	"good cut" : "Reflects most light that enters, represents around a quarter of diamonds. Good quality cut to optimize the size without sacrificing quality or beauty. In monetary terms the Good Cut diamonds are far less costly than the Very Good Cut ones.",
	"fair cut" : "Fair Cut diamonds are just about reasonable, speaks to thirty five percent of the precious stones. This is the lower quality cut approved for jewellery, by experts.",
	"ideal cut" : "The Ideal Cut diamond are just a pinnacle of brilliance, capturing nearly all light with unmatched radiance, epitomizing perfection in craftsmanship."
}


/* diamond carat graphic component */
const DiamondCaratGraphicComp = {
    props : ["diamond"],
    delimiters: ['[[', ']]'],
    template : `#diamond-carat-graphic`,
    computed : {
    	getCaratTitle() {
    		return graphicsMetaData['caratText']
    	},
        getCaratMeterGraphicImgUrl() {
            return `${baseAssetsUrl}/diamond_carat.png`
            // return `${baseAssetsUrl}diamond_carat_meter.png`
        },
        getCaratPosition() {
            return function(carat) {
                var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                var width = 92

                    if (carat > 0 && carat <= 0.25) {
                        var start = 0, end= 9.1
                        let diff = end-start 
                        let caratstartDiff = parseFloat(carat).toFixed(2)
                        let caratDiff = 0.25
                        let distance = diff/caratDiff
                        width = distance*caratstartDiff
                    } else if (carat > 0.25 && carat <= 0.5) {
                        var start = 9.1, end= 16.5
                        let diff = end-start //8.5
                        let caratstartDiff = parseFloat(carat-0.25).toFixed(2)
                        let caratDiff = 0.25
                        let distance = diff/caratDiff
                        width = 9.1 + distance*caratstartDiff
                        /* var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 7.0 */
                    } else if (carat > 0.50 && carat <= 0.75) {
                        var start = 16.5, end= 24.3
                        let diff = end-start //8
                        let caratstartDiff = parseFloat(carat-0.5).toFixed(2)
                        let caratDiff = 0.25
                        let distance = diff/caratDiff
                        width = 16.5 + distance*caratstartDiff
                        /* var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 7.0 */
                    } else if (carat > 0.75 && carat <= 1.0) { 
                        var start = 24.3, end= 31.45
                        let diff = end-start //8
                        let caratstartDiff = parseFloat(carat-0.75).toFixed(2)
                        let caratDiff = 0.25
                        let distance = diff/caratDiff
                        width = 24.3 + distance*caratstartDiff                  
                        /* var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 7.0 */
                    } else if (carat > 1.0 && carat <= 1.5) {
                        var start = 31.45, end= 38.8
                        let diff = end-start //9
                        let caratstartDiff = parseFloat(carat-1).toFixed(2)
                        let caratDiff = 0.5
                        let distance = diff/caratDiff
                        width = 31.45 + distance*caratstartDiff                     
                        /* var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 7.0 */
                    } else if (carat > 1.5 && carat <= 2) {  
                        var start = 38.8, end= 47
                        let diff = end-start //10
                        let caratstartDiff = parseFloat(carat-1.5).toFixed(2)
                        let caratDiff = 0.5
                        let distance = diff/caratDiff
                        width = 38.8 + distance*caratstartDiff                   
                        /* var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 6.0 */
                    } else if (carat > 2 && carat <= 3) {    
                        var start = 47, end= 55.8
                        let diff = end-start //10
                        let caratstartDiff = parseFloat(carat-2).toFixed(2)
                        let caratDiff = 1
                        let distance = diff/caratDiff
                        width = 47 + distance * caratstartDiff                    
                       /*  var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 6.0 */
                    } else if (carat > 3 && carat <= 4) {    
                        var start = 55.8, end= 65.3
                        let diff = end-start //11
                        let caratstartDiff = parseFloat(carat-3).toFixed(2)
                        let caratDiff = 1
                        let distance = diff/caratDiff
                        width = 55.8 + distance * caratstartDiff                    
                       /*  var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 6.0 */
                    } else if (carat > 4 && carat <= 5) {    
                        var start = 65.3, end= 75.8
                        let diff = end-start //12
                        let caratstartDiff = parseFloat(carat-4).toFixed(2)
                        let caratDiff = 1
                        let distance = diff/caratDiff
                        width = 65.3 + distance * caratstartDiff                    
                       /*  var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 6.0 */
                    } else if (carat > 5 && carat <= 10) {    
                        var start = 75.8, end= 87.8
                        let diff = end-start //14
                        let caratstartDiff = parseFloat(carat-5).toFixed(2)
                        let caratDiff = 5
                        let distance = diff/caratDiff
                        width = 75.8 + distance * caratstartDiff                    
                       /*  var interval = 0.48
                        var width = (carat * 100)
                        width = (width * interval)
                        width = width - 6.0 */
                    }
                if (screenwidth < 485) {
                    width = width + 8
                }
                return width
            }
        }
    }
}

/* diamond cut graphic component */
const DiamondCutGraphicComp = {
    props : ["diamond"],
    delimiters: ['[[', ']]'],
    template : `#diamond-cut-graphic`,
    computed : {
    	getCutTitle() {
    		return graphicsMetaData['cutText']
    	},
    	getCutOptionTitle() {
    		return (diamondCut) => {
    			return graphicsMetaData[`${diamondCut ? diamondCut.toLowerCase() : 'good'} cut`] 
    		}
    	},
        getCutMeterGraphicImgUrl() {
            return `${baseAssetsUrl}/diamond_cut.png`
            // return `${baseAssetsUrl}diamond_cut_meter.png`
        },        
        getCutPosition() {
            return function(cut) {
                var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                /* if(screenwidth < 768) {
                   return 0
                } */
                var cutwidth = {}
                if(this.newlayout){
                    cutwidth = {
                        "ideal" : 87.4,
                        "excellent" : 69.6,
                        "very good" : 51.9,
                        "good" : 34,
                        "fair" : 16.2,
                        "poor" : 30
                    }
                } else if(!this.newlayout){
                    cutwidth = {
                        "ideal" : 69,
                        "excellent" : 58,
                        "very good" : 41,
                        "good" : 23,
                        "fair" : 5,
                        "poor" : 30
                    }
                }
                return cut ? cutwidth[cut.toLowerCase()] : ''                
            }
        },        
    },
    updated() {                
        if (this.$props.diamond.cut) {
            var cutPopupArrowPosition = this.getCutPopupArrowPosition(this.$props.diamond.cut)
            var styleElement = document.head.appendChild(document.createElement("style"))
            styleElement.innerHTML = `.popover_cut.arrow_box::after, .popover_cut.arrow_box::before {left:${cutPopupArrowPosition}%}`
        }  
    },
    methods : {
        getCutPopupArrowPosition(cut) {            
            var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if(screenwidth < 768) {
                var cutArrowWidth = {
                    "excellent" : 20,
                    "ideal" : 20,
                    "very good" : 20,
                    "good" : 20,
                    "fair" : 20,
                    "poor" : 20
                }
            } else {
                var cutArrowWidth = { 
                    "excellent" : 20,
                    "ideal" : 20,
                    "very good" : 20,
                    "good" : 20,
                    "fair" : 20,
                    "poor" : 20
                }
            }    
            return cut ? cutArrowWidth[cut.toLowerCase()] : ''
        },
    }
}

/* diamond color graphic component */
const DiamondColorGraphicComp = {
    props : ["diamond"],
    delimiters: ['[[', ']]'],
    template : `#diamond-color-graphic`,
    computed : {
    	getColorTitle() {
    		return graphicsMetaData['colorText']
    	},
    	getColorOptionTitle() {
    		return (colorOption) => {
    			return graphicsMetaData[`${colorOption}Color`]
    		}
    	},
        getColorMeterGraphicImgUrl() {
            return `${baseAssetsUrl}/diamond_color.png`
            // return `${baseAssetsUrl}diamond_color_meter.png`
        },
        getColorSpecificImgUrl() {
            return function(color) {
                return color ? `${baseAssetsUrl}/${color.toLowerCase()}.png` : ''
            }
        },
        getColorPosition(color) {
            return function(color) {
                var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                /* if(screenwidth < 768) {
                   return 0
                } */
                var colorwidth ={};
                if(this.newlayout){
                    colorwidth =  { 
                        "D" : 2,
                        "E" : 10.5,
                        "F" : 18.5,
                        "G" : 30,
                        "H" : 38,
                        "I" : 46,
                        "J" : 54,
                        "K" : 66,
                        "L" : 74,
                        "M" : 82,
                        "N" : 90,
                    }
                } else if(!this.newlayout){
                    colorwidth = { 
                        "D" : 0,
                        "E" : 0,
                        "F" : 7.5,
                        "G" : 19,
                        "H" : 27,
                        "I" : 35,
                        "J" : 43,
                        "K" : 54.5,
                        "L" : 62.5,
                        "M" : 70.5,
                        "N" : 70.5
                    }
                }
                return color ? colorwidth[color.toUpperCase()] : ''                
            }
        },
        getColorImgPosition() {
            return function(color) {
                var colorwidth = {};
                if(this.newlayout){
                    colorwidth = {
                        "D" : 2,
                        "E" : 10.5,
                        "F" : 18.5,
                        "G" : 30,
                        "H" : 38,
                        "I" : 46,
                        "J" : 54,
                        "K" : 66,
                        "L" : 74,
                        "M" : 82,
                        "N" : 90,
                    }
                } else if(!this.newlayout){
                    colorwidth = { 
                        "D" : 0,
                        "E" : 0,
                        "F" : 7.5,
                        "G" : 19,
                        "H" : 27,
                        "I" : 35,
                        "J" : 70.5,
                        "K" : 54.5,
                        "L" : 62.5,
                        "M" : 70.5,
                        "N" : 70.5
                    }
                }
                return color ? colorwidth[color.toUpperCase()] : ''
            }
        },        
    },
    updated() {                
        if (this.$props.diamond.color) {
            var colorPopupArrowPosition = this.getColorPopupArrowPosition(this.$props.diamond.color)
            var styleElement = document.head.appendChild(document.createElement("style"))
            styleElement.innerHTML = `.popover-color .arrow_box::after, .popover-color .arrow_box::before {left:${colorPopupArrowPosition}%}`
        }  
    },
    methods : {
        getColorPopupArrowPosition(color) {            
            var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if(screenwidth < 768) {
                var colorarrowwidth = { 
                    "D" : 2,
                    "E" : 8,
                    "F" : 13.5,
                    "G" : 20,
                    "H" : 26,
                    "I" : 32,
                    "J" : 38,
                    "K" : 43.5,
                    "L" : 49,
                    "M" : 55,
                }
            } else {
                return 6
            }    
            return color ? colorarrowwidth[color.toUpperCase()] : ''
        },
    }
}

/* diamond clarity graphic component */
const DiamondClarityGraphicComp = {
    props : ["diamond"],
    delimiters: ['[[', ']]'],
    template : `#diamond-clarity-graphic`,
    computed : {
    	getClarityTitle() {
    		return graphicsMetaData['clarityText']
    	},
    	getClarityOptionTitle() {
    		return (clarityOption) => {
    			return graphicsMetaData[`${clarityOption}Clarity`]
    		}
    	}, 
        getClarityMeterGraphicImgUrl() {
            return `${baseAssetsUrl}/diamond_clartiy.png`
            // return `${baseAssetsUrl}diamond_clarity_meter.png`
        },     
        getClarityPosition() {
            return function(clarity) {
                var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
/*                 if(screenwidth < 768) {
                   return 0;
                } */
                var claritywidth = {}
                if(this.newlayout){
                    claritywidth = { 
                        "fl" : 1,
                        "if" : 19,
                        "vvs1" : 31.5,
                        "vvs2" : 31.2,
                        "vs1"  : 43,
                        "vs2"  : 43.5,
                        "si1"  : 57,
                        "si2"  : 64,
                        "si3"  : 64.5,
                        "i1"   : 76,
                        "i2"   : 77,
                        "i3"   : 83.5
                    }
                }
                else if(!this.newlayout){
                    claritywidth = { 
                        "fl" : 1.5,
                        "if" : 14,
                        "vvs1" : 25,
                        "vvs2" : 28,
                        "vs1"  : 38,
                        "vs2"  : 41,
                        "si1"  : 52,
                        "si2"  : 58.3,
                        "si3"  : 60.3,
                        "i1"   : 70,
                        "i2"   : 72,
                        "i3"   : 72
                    }
                }
                return clarity ? claritywidth[clarity.toLowerCase()] : ''
            }
        },           
    },
    updated() {                
        if (this.$props.diamond.clarity) {
            var clarityPopupArrowPosition = this.getClarityPopupArrowPosition(this.$props.diamond.clarity)
            var styleElement = document.head.appendChild(document.createElement("style"))
            styleElement.innerHTML = `.popover-clarity.arrow_box::after, .popover-clarity.arrow_box::before {left:${clarityPopupArrowPosition}%}`
        }  
    },
    methods : {
        getClarityPopupArrowPosition(clarity) {
            var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if(screenwidth < 768) {
               var clarity_arrow_width = { 
                    "fl" : 54,
                    "if" : 54,
                    "vvs1" : 54,
                    "vvs2" : 54,
                    "vs1"  : 54,
                    "vs2"  : 54,
                    "si1"  : 54,
                    "si2"  : 54,
                    "i1"   : 54,
                    "i2"   : 54,
                    "i3"   : 54
                }
            } else {
                var clarity_arrow_width = { 
                    "fl" : 54,
                    "if" : 54,
                    "vvs1" : 54,
                    "vvs2" : 54,
                    "vs1"  : 54,
                    "vs2"  : 54,
                    "si1"  : 54,
                    "si2"  : 54,
                    "i1"   : 54,
                    "i2"   : 54,
                    "i3"   : 54
                }  
            }
            return clarity ? clarity_arrow_width[clarity.toLowerCase()] : ''
        }
    }
}